import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  CREATE_QUOTE_START,
  GET_QUOTES_START,
  GET_QUOTE_START,
  UPDATE_QUOTE_START,
  CHANGE_QUOTE_STATUS_START,
  GENERATE_QUOTE_PDF_START,
} from "./constant";

import {
  createQuoteSuccess,
  createQuoteFail,

  getQuotesSuccess,
  getQuotesFail,

  getQuoteSuccess,
  getQuoteFail,

  updateQuoteSuccess,
  updateQuoteFail,

  changeQuoteStatusSuccess,
  changeQuoteStatusFail,

  generateQuotePdfSuccess,
  generateQuotePdfFail,
} from "./action";

import {
  createQuoteAPI,
  getQuotesAPI,
  getQuoteAPI,
  updateQuoteAPI,
  changeQuoteStatusAPI,
  generateQuotePdfAPI,
} from "./api";



// =====================================
// Create Quote
// =====================================

function* createQuote({ payload }) {
  try {

    const response = yield call(createQuoteAPI, payload);

    yield put(createQuoteSuccess(response.data));

  } catch (error) {

    yield put(createQuoteFail(error.response?.data?.message || error.message));

  }
}



// =====================================
// Get Quotes
// =====================================

function* getQuotes({ payload }) {
  try {

    const response = yield call(getQuotesAPI, payload);

    yield put(getQuotesSuccess(response.data));

  } catch (error) {

    yield put(getQuotesFail(error.response?.data?.message || error.message));

  }
}



// =====================================
// View Quote
// =====================================

function* getQuote({ payload }) {
  try {

    const response = yield call(getQuoteAPI, payload);

    yield put(getQuoteSuccess(response.data));

  } catch (error) {

    yield put(getQuoteFail(error.response?.data?.message || error.message));

  }
}



// =====================================
// Update Quote
// =====================================

function* updateQuote({ payload }) {
  try {

    const response = yield call(updateQuoteAPI, payload);

    yield put(updateQuoteSuccess(response.data));

  } catch (error) {

    yield put(updateQuoteFail(error.response?.data?.message || error.message));

  }
}



// =====================================
// Change Quote Status
// =====================================

function* changeQuoteStatus({ payload }) {
  try {

    const response = yield call(changeQuoteStatusAPI, payload);

    yield put(changeQuoteStatusSuccess(response.data));

  } catch (error) {

    yield put(changeQuoteStatusFail(error.response?.data?.message || error.message));

  }
}



// =====================================
// Generate Quote PDF
// =====================================

function* generateQuotePdf({ payload }) {
  try {

    const response = yield call(generateQuotePdfAPI, payload);

    yield put(generateQuotePdfSuccess(response.data));

  } catch (error) {

    yield put(generateQuotePdfFail(error.response?.data?.message || error.message));

  }
}



// =====================================
// Watchers
// =====================================

export function* watchCreateQuote() {
  yield takeEvery(CREATE_QUOTE_START, createQuote);
}

export function* watchGetQuotes() {
  yield takeEvery(GET_QUOTES_START, getQuotes);
}

export function* watchGetQuote() {
  yield takeEvery(GET_QUOTE_START, getQuote);
}

export function* watchUpdateQuote() {
  yield takeEvery(UPDATE_QUOTE_START, updateQuote);
}

export function* watchChangeQuoteStatus() {
  yield takeEvery(CHANGE_QUOTE_STATUS_START, changeQuoteStatus);
}

export function* watchGenerateQuotePdf() {
  yield takeEvery(GENERATE_QUOTE_PDF_START, generateQuotePdf);
}



// =====================================
// Root Saga
// =====================================

function* QuoteSaga() {
  yield all([
    fork(watchCreateQuote),
    fork(watchGetQuotes),
    fork(watchGetQuote),
    fork(watchUpdateQuote),
    fork(watchChangeQuoteStatus),
    fork(watchGenerateQuotePdf),
  ]);
}

export default QuoteSaga;
